import { RemoteGetUserInfoCognito } from 'infra/http/cognito/remote-get-user-info-cognito'
import { UserService } from 'infra/services/user-service'
import { makeAccessTokenCache } from '../cache/set-access-token-cache-factory'

export const makeUserService = (): UserService => new UserService(new RemoteGetUserInfoCognito(makeAccessTokenCache()))
